import {
    useContext,
    type FC
} from "react";
import type ISidebarGroupActionProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    SidebarGroupLabelContext,
    useSidebarRootContext
} from "../../context";
import {
    Plus as PlusIcon
} from "lucide-react-native";
import {
    getSidebarActionPlacement,
    getSidebarMeasures
} from "../../stylesheet";
import {
    getSidebarActionRadius
} from "../../util";
import SidebarIconButton from "../iconButton";

const SidebarGroupActionIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => <PlusIcon
    color={customColor}
    size={size}
/>;

const SidebarGroupAction: FC<ISidebarGroupActionProps> = ({
    icon = SidebarGroupActionIcon,
    customTheme: customThemeProp,
    isDisabled = false,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.GroupAction"
    });

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        iconSizes,
        radiuses,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const isInLabel = useContext(SidebarGroupLabelContext);

    const measures = getSidebarMeasures({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        spaces
    });

    const placement = getSidebarActionPlacement({
        inset: (measures.square - iconSizes.medium) / 2,
        height: controlHeights.small,
        touchTargets,
        pointerType,
        iconSizes,
        spaces
    });

    const radius = getSidebarActionRadius({
        inset: (controlHeights.small - placement.visualSize) / 2,
        outer: radiuses.actions,
        radiuses
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlHeights,
        shapeConfigs,
        isInLabel,
        placement,
        measures,
        spaces
    });

    if(root?.isCollapsed) {
        return null;
    }

    return <SidebarIconButton
        {...props}
        style={[
            style,
            isInLabel ? undefined : stylesheet.container,
            containerDynamicStyle
        ]}
        customTheme={customTheme}
        isDisabled={isDisabled}
        placement={placement}
        radius={radius}
        icon={icon}
    />;
};
export default SidebarGroupAction;
